import { SOCIAL_MEDIA_LINKS } from './social-media';

export const SOCIAL_LINKS = {
    'facebook-link': {
        link: SOCIAL_MEDIA_LINKS['boon-facebook'],
        icon: 'facebook',
    },
    'instagram-link': {
        link: SOCIAL_MEDIA_LINKS['boon-instagram'],
        icon: 'instagram',
    },
    'email-link': {
        link: `mailto:${SOCIAL_MEDIA_LINKS['boon-email-hello']}`,
        icon: 'email',
    },
};

export const FOOTER_LINKS = [
    {
        text: 'footer-the-company',
        link: '/about-us',
    },
    {
        text: 'footer-partner-with-us',
        link: '/partner-with-us',
    },
    {
        text: 'footer-how-it-works',
        link: '/faq',
    },
    {
        text: 'footer-terms-and-conditions',
        link: '/terms-and-conditions',
    },
    {
        text: 'footer-refer-a-friend',
        link: '/refer-a-friend',
    },
    {
        text: 'footer-contact-us',
        link: '/contact-us',
    },
];
